module.exports = __webpack_public_path__ + "static/img/4.156ba98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/HeavyCopper/4.png
// module id = RPOi
// module chunks = 1